import { GetLocalStorageValue } from '../../../../_config/utils/get-local-storage-value.util';

const user = GetLocalStorageValue('userInfo');

console.log("aca",user)

export const checkRol = (pharmacy) => {
	if (user?.pharmacy) return '/v2/pharmacy-locals/list';
	return `/v2/admin-pharmacy-locals/list`;
};
